import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlane, faDollarSign, faSuitcase } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import "./FlightList.css";
import FlightDealsBanner from "./FlightDealsBanner";
import FlightPopup from "./FlightPopup";
import FlightSearchPage from "../FlightSearchPage/FlightSearchPage";

const flightDeals = [
  {
    id: 1,
    name: "First Class Flight Deal",
    description: "Experience unmatched comfort, premium service, and exclusive lounges on your first-class journey.",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741050/photo-1573988535312-5766c0c5f42f_p8dymm.jpg",
    price: "1500+",
  },
  {
    id: 2,
    name: "Group Travel Flight Deal",
    description: "Ideal for friends, families, or corporate groups looking for flexible, discounted group fares.",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741065/blog-4_cr4cej.png",
    price: "499+",
  },
  {
    id: 3,
    name: "Business Class Flight Deal",
    description: "Work comfortably with lie-flat seating, gourmet dining, and lounge access to make business travel effortless.",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741083/TAL-First-Class-Seat-UPGRADEASK0223-41f98c66e49146deb5f986bc61a59135_cjnseo.jpg",
    price: "999+",
  },
  {
    id: 4,
    name: "Low Cost Carrier",
    description: "Affordable fares with essential services included, perfect for budget-conscious travelers.",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741096/9ca327cc-c440-48b5-a06e-76c0fe8006e6_fpfyok.jpg",
    price: "199+",
  },
];

const topRoutes = [
  {
    id: 1,
    from: "New York",
    to: "Miami",
    price: "$220",
    discount: "-20%",
    oldPrice: "$275",
    departure: "12:30",
    arrival: "15:45",
    tag: "Best Seller",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741110/images_zpzr4u.jpg",
  },
  {
    id: 2,
    from: "Los Angeles",
    to: "Chicago",
    price: "$180",
    discount: "HOT",
    oldPrice: "$220",
    departure: "09:20",
    arrival: "13:00",
    tag: "Limited Time",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741127/475457-Los-Angeles_oywxlh.jpg",
  },
  {
    id: 3,
    from: "Dallas",
    to: "Las Vegas",
    price: "$150",
    discount: "-15%",
    oldPrice: "$175",
    departure: "14:00",
    arrival: "16:40",
    tag: "Weekend Deal",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741147/photo-1542314831-068cd1dbfeeb_ryntfl.jpg",
  },
  {
    id: 4,
    from: "San Francisco",
    to: "Seattle",
    price: "$130",
    discount: "SUN ONLY",
    oldPrice: "$160",
    departure: "11:30",
    arrival: "13:45",
    tag: "Sunday Offer",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741161/photo-1544620347-c4fd4a3d5957_tefmwa.jpg",
  },
];

const airlines = [
  {
    id: 1,
    name: "Delta Air Lines",
    logo: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741184/DL-splash2_gtcpj5.jpg",
    tagline: "Trusted global connectivity",
  },
  {
    id: 2,
    name: "American Airlines",
    logo: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741199/240103-Newsroom-Holiday-travel_yqawx0.jpg",
    tagline: "Fly with confidence",
  },
  {
    id: 3,
    name: "United Airlines",
    logo: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741211/united-airlines-boeing-plane-denver_uvctc8.jpg",
    tagline: "Fly the friendly skies",
  },
  {
    id: 4,
    name: "Southwest Airlines",
    logo: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741227/987e1130-999b-4503-a4f0-8d1dd365c75f-large16x9_AP23352077528762_lpmodk.jpg",
    tagline: "Low fares. Nothing to hide.",
  },
  {
    id: 5,
    name: "Alaska Airlines",
    logo: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741249/8697_ak_hero_plane_16x9_mbr_m1a_gbwxwa.png",
    tagline: "For the places you go",
  },
  {
    id: 6,
    name: "JetBlue Airways",
    logo: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741266/jetblue-a320-flight_yknh1q.jpg",
    tagline: "You above all",
  },
  {
    id: 7,
    name: "Spirit Airlines",
    logo: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741285/jpeg_smkoje.jpg",
    tagline: "Less money. More go.",
  },
  {
    id: 8,
    name: "Hawaiian Airlines",
    logo: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741301/M2_Livery_c1d06cc0-a92f-42f4-902c-50fbea1f1a6e-prv_rkgudb.png",
    tagline: "Aloha in the air",
  },
];

const FlightList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (location.pathname === "/flight") {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  // handle opening popup on any click
  const handleCardClick = () => {
    setShowPopup(true);
  };

  return (
    <>
      <section className="flight-grid-wrapper">
        <div className="banner-heading flight-list-heading">
          <motion.h2
            className="section-heading"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <FontAwesomeIcon icon={faPlane} style={{ marginRight: "8px" }} />
            Flight Deals & Offers
          </motion.h2>
          <p className="section-subtext">
            Explore our curated flight deals for every budget and travel style — from first-class luxury to cost-saving carriers.
          </p>
        </div>
        <FlightSearchPage  setShowPopup={setShowPopup}/>

        <div className="flight-grid">
          {flightDeals.map((deal, i) => (
            <motion.div
              key={deal.id}
              className="flight-card"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.2 }}
              whileHover={{ scale: 1.03 }}
              onClick={handleCardClick}
            >
              <div className="card-img-wrapper">
                <img src={deal.image} alt={deal.name} />
                <span className="flight-price">
                  <FontAwesomeIcon icon={faDollarSign} /> {deal.price}
                </span>
              </div>
              <div className="flight-card-body">
                <h3>{deal.name}</h3>
                <p>{deal.description}</p>
                <div className="flight-extra">
                  <FontAwesomeIcon icon={faSuitcase} /> Flexible booking
                </div>
                <div className="flight-buttons">
                  <button
                    className="book-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCardClick();
                    }}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {location.pathname === "/flight" && (
        <>
          <FlightDealsBanner />
          <section className="top-routes-wrapper">
            <h2 className="routes-heading">Top Flight Routes <span>within USA</span></h2>
            <div className="routes-grid">
              {topRoutes.map((route, index) => (
                <motion.div
                  key={route.id}
                  className="route-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  onClick={handleCardClick}
                >
                  <div className="route-image">
                    <img src={route.image} alt={`${route.from} to ${route.to}`} />
                    <span className="discount-badge">{route.discount}</span>
                    <div className="route-price">
                      <span className="old">{route.oldPrice}</span>
                      <span className="current">{route.price}</span>
                    </div>
                  </div>
                  <div className="route-info">
                    <h3>{route.from} to {route.to}</h3>
                    <p className="route-time">
                      Departure: <span>{route.departure}</span> | Arrival: <span>{route.arrival}</span>
                    </p>
                    {route.tag && <span className="route-tag">{route.tag}</span>}
                  </div>
                </motion.div>
              ))}
            </div>
          </section>

          <section className="top-airlines-wrapper">
            <h2 className="airlines-heading">Top USA Airlines</h2>
            <div className="airlines-grid">
              {airlines.map((airline, i) => (
                <motion.div
                  key={airline.id}
                  className="airline-card"
                  onClick={()=>setShowPopup(true)}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                >
                  <div className="airline-image">
                    <img src={airline.logo} alt={airline.name} />
                    <div className="airline-text-overlay">
                      <h3>{airline.name}</h3>
                      <p>{airline.tagline}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </section>
        </>
      )}
      {showPopup && <FlightPopup onClose={() => setShowPopup(false)} />}
    </>
  );
};

export default FlightList;
